export default __webpack_public_path__ + "static/B0077-bf9c29e6755e1885c480e905ed1da020.png";